import Vue from 'vue'
import Router from 'vue-router'
import Monitoring from '../components/Monitoring.vue'
import Administrative from '../components/Administrative.vue'
Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/monitoring',
      name: 'monitoring',
      component: Monitoring
    },
    {
      path: '/administrative',
      name: 'administrative',
      component: Administrative
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js